import React, { useEffect, useState } from 'react';
import "./JobSettings.scss";
import HourlyJobTable from './JobSettingsTabs/HourlyJobTable';
import apiClient from "../../../../../../Config/apiClient";
import Loader from "../../../../../../Context/Loader/Loader";
import { showSuccessToast, showErrorToast } from "../../../../../../Context/Toaster/Toaster";

const jobSettingsPath = process.env.REACT_APP_HS_JOB_SETTINGS_BASE_PATH;

const JobSettings = () => {
  const [settings, setSettings] = useState(null);
  const [activeTab, setActiveTab] = useState("tab1");
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        setLoading(true);
        const res = await apiClient.get(`${jobSettingsPath}/get`);
        if (res.data.status === "SUCCESS") {
          setSettings(res.data.data);
        }
      } catch (error) {
        showErrorToast("Failed to fetch job settings");
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, []);

  const handleSave = async () => {
    try {
      setSaving(true);
      const res = await apiClient.put(`${jobSettingsPath}/update`, {
        auto_lock_job: settings?.auto_lock_job || 0,
        lock_time: settings?.lock_time != null ? parseInt(settings.lock_time, 10) : 4,
        hourly_job_comp: settings?.hourly_job_comp || 0,
        comp_hours: settings?.comp_hours || "",
        checkin_lock: settings?.checkin_lock || 0,
        checkin_lock_time: settings?.checkin_lock_time || "4 hours",
        min_job_posting_hours: settings?.min_job_posting_hours || "12",
      });

      if (res.data.status === "SUCCESS") {
        setSettings(res.data.data);
        showSuccessToast("Job settings updated successfully!");
      }
    } catch (error) {
      showErrorToast("Failed to update job settings");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="text-center"><Loader /></div>;

  return (
    <div className="report-wraper">
      <div className="tab-content" id="myTabContent">
        <div className="tab-pane fade show active" id="start" role="tabpanel" aria-labelledby="start-tab">
          <div className='report-tabinner'>
            <div className="reportform-cover mt-0">

              <div className="vrt-split mb-3">
                <h3>Job Posting Lead Time</h3>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="cp-split">
                    <label className="fi-label">Minimum hours before start time that a job can be posted <span style={{ color: "red" }}>*</span></label>
                    <select
                      className="common-select"
                      value={settings?.min_job_posting_hours || "12"}
                      onChange={(e) => setSettings((prev) => ({ ...prev, min_job_posting_hours: e.target.value }))}
                    >
                      <option value="12">12 Hours</option>
                      <option value="24">24 Hours</option>
                      <option value="48">48 Hours</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="vrt-split mb-3 mt-4">
                <h3>Job Expiry</h3>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="cp-split">
                    <div className="hscommon-check">
                      <input className="common-check" type="checkbox" id="autoLockJob" checked={!!settings?.auto_lock_job} onChange={(e) => setSettings((prev) => ({ ...prev, auto_lock_job: e.target.checked ? 1 : 0, }))} />
                      <label className="form-check-label" htmlFor="autoLockJob">
                        Auto Lock Jobs <span style={{ color: "red" }}>*</span>
                      </label>
                    </div>
                    <select className="common-select" value={settings?.lock_time || 4} onChange={(e) => setSettings((prev) => ({ ...prev, lock_time: parseInt(e.target.value, 10) }))} >
                      {[3,4,5,6,7,8,9,10,11].map((h) => (
                        <option key={h} value={h}>Before {h} Hours of Start Time</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <div className="vrt-split mb-3 mt-4">
                <h3>Driver Check-In Window</h3>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="cp-split">
                    <div className="hscommon-check">
                      <input className="common-check" type="checkbox" id="checkinLock" checked={!!settings?.checkin_lock} onChange={(e) => setSettings((prev) => ({ ...prev, checkin_lock: e.target.checked ? 1 : 0, }))} />
                      <label className="form-check-label" htmlFor="checkinLock">
                        Restrict Early Check-In <span style={{ color: "red" }}>*</span>
                      </label>
                    </div>
                    <select className="common-select" value={settings?.checkin_lock_time || "4 hours"} onChange={(e) => setSettings((prev) => ({ ...prev, checkin_lock_time: e.target.value, }))} >
                      <option value="1 hour">No Earlier Than 1 Hour Before Start</option>
                      <option value="2 hours">No Earlier Than 2 Hours Before Start</option>
                      <option value="4 hours">No Earlier Than 4 Hours Before Start</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="vrt-split vrt-padding mt-2 mb-3">
                  <h3>
                    Cancellation Charges <span className='italic-text'>(If Job Already Started)</span>
                  </h3>
                </div>
                <div className="col-md-12 inner-tab-container">
                  <div className="aptab-header mb-3">
                    <ul className="nav nav-tabs innertab-list" id="myTab" role="tablist">
                      {[
                        { id: "tab1", label: "Hourly Job" },
                      ].map(({ id, label }) => (
                        <li className="nav-item" role="presentation" key={id}>
                          <button className={`nav-link tab-btn ${activeTab === id ? "active" : ""}`} onClick={() => setActiveTab(id)}>
                            {label}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="aptab-body">
                    {activeTab === "tab1" && (
                      <HourlyJobTable checked={!!settings?.hourly_job_comp}
                        onCheckChange={(e) => setSettings((prev) => ({ ...prev, hourly_job_comp: e.target.checked ? 1 : 0, }))}
                        options={["4 Hours", "8 Hours"]}
                        onOptionChange={(e) => setSettings((prev) => ({ ...prev, comp_hours: e.target.value, }))}
                      />
                    )}
                  </div>
                </div>
              </div>

              <div className="row mt-3" style={{ marginBottom: '30px' }}>
                <div className="col-md-12">
                  <button className="cp-button generate-button" onClick={handleSave} disabled={saving}>
                    {saving ? <Loader /> : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobSettings;